/* 🤖 this file was generated by svg-to-ts */
export const emperorIconShare: {
  name: 'share';
  data: string;
} = {
  name: 'share',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M18 14c-1.2 0-2.266.54-3 1.38L9.9 12.83c.05-.27.09-.55.09-.84 0-.29-.04-.57-.1-.84l5.09-2.55c.73.84 1.8 1.38 3 1.38 2.2 0 4-1.795 4-4 0-2.206-1.8-4-4-4 -2.21 0-4 1.794-4 4 0 .28.03.56.09.83L8.97 9.36c-.734-.84-1.8-1.39-3-1.39 -2.205 0-4 1.79-4 4 0 2.205 1.795 4 4 4 1.2 0 2.266-.55 3-1.39l5.09 2.54c-.06.27-.1.55-.1.83 0 2.2 1.795 4 4 4 2.2 0 4-1.8 4-4 0-2.205-1.8-4-4-4Z"/></svg>`
};
